export function getFixedFieldName(fieldName: string) {
  // We have to replace dots with other token to work around the way data is stored in final-form
  return `field-${fieldName.replace('.', '___')}`;
}
